import visitedLinksSlice from './slice';

// eslint-disable-next-line import/prefer-default-export
export const { setEducatorsAppVisited } = visitedLinksSlice.actions;
